import React from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { CrossIconComponent } from '../../../../../components/assets';
import { t } from '../../../../../i18n';
import LessonSidebarLink from './lesson-sidebar-link';
import './styles.scss';

const LessonsListSidebar = ({ lessons, showForMobile, onHideForMobile }) => {
  const sidebarContent = (
    <div className="courses-watch-lessons-list">
      <div className="courses-watch-lessons-list__header">
        <h2 className="courses-watch-lessons-list__title">{t('DIGITAL_COURSES.WATCH.LESSONS_LIST')}</h2>
        <CrossIconComponent className="courses-watch-lessons-list__close-mobile-sidebar" onClick={onHideForMobile} />
      </div>
      {lessons.length === 1 && (
        <LessonSidebarLink
          key={lessons[0].lessonNumber}
          to={lessons[0].watchUrl}
          titleText={lessons[0].title}
          isCurrent={lessons[0].isCurrent}
          isCompletedByUser={lessons[0].isCompletedByUser}
          onClick={onHideForMobile}
        />
      )}
      {lessons.length >= 2 &&
        lessons.map(l => (
          <LessonSidebarLink
            key={l.lessonNumber}
            to={l.watchUrl}
            titleText={t('DIGITAL_COURSES.WATCH.LESSON_NUMBER', { number: l.lessonNumber })}
            subtitleText={l.title}
            isCurrent={l.isCurrent}
            isCompletedByUser={l.isCompletedByUser}
            onClick={onHideForMobile}
          />
        ))}
    </div>
  );

  return (
    <>
      <MobileOffcanvasLayout show={showForMobile} onHide={onHideForMobile}>
        {sidebarContent}
      </MobileOffcanvasLayout>
      <DesktopSidebarLayout>{sidebarContent}</DesktopSidebarLayout>
    </>
  );
};

export default LessonsListSidebar;

const MobileOffcanvasLayout = ({ show, onHide, children }) => (
  <Offcanvas show={show} onHide={onHide} className="courses-watch-lessons__sidebar-layout_mobile">
    <Offcanvas.Body>{children}</Offcanvas.Body>
  </Offcanvas>
);

const DesktopSidebarLayout = ({ children }) => (
  <div className="courses-watch-lessons__sidebar-layout_desktop">{children}</div>
);
